// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"354":"80942b5a","754":"80942b5a","2151":"021b5d62","2630":"80942b5a","5473":"71198be4","7673":"80942b5a","8311":"80942b5a","8681":"80942b5a","8755":"80942b5a","9428":"80942b5a"}[chunkId] + ".chunk.css";
};